import { render, staticRenderFns } from "./h3-checkbox-list.vue?vue&type=template&id=2155a63e&"
import script from "./h3-checkbox-list.vue?vue&type=script&lang=js&"
export * from "./h3-checkbox-list.vue?vue&type=script&lang=js&"
import style0 from "./h3-checkbox-list.vue?vue&type=style&index=0&id=2155a63e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports